import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import * as types from './mutation-type';
import dataTiers from './modules/dataTiers';
import user from './modules/user';
import facture from './modules/facture';

Vue.use(Vuex);

function dateTimeReviver(key, value) {
  let resultRegex;
  if (typeof value === 'string') {
    resultRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/.exec(value);
    if (resultRegex) {
      return new Date(value);
    }
  }
  return value;
}

const store = new Vuex.Store({
  modules: {
    dataTiers,
    user,
    facture,
  },
  plugins: [createPersistedState({
    key: 'affixe2_ui_portailclient',
    getState(key, storage) {
      try {
        const localValue = storage.getItem(key);
        let state;
        if (localValue !== 'undefined') {
          state = JSON.parse(localValue, dateTimeReviver);
        }
        return state;
      } catch (err) {
        /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      }

      return undefined;
    },
    paths: ['user.user', 'user.hash', 'user.dataConnexion', 'dataTiers.departements', 'user.tiersId'],
  })],
});

export default store;

export function resetState() {
  ['dataTiers', 'user'].forEach((module) => {
    store.commit(module + '/' + types.RESET_STATE);
  });
}
